import React from 'react';
import QuoteThankYou from 'components/commercetools-ui/quotes/thnak-you';

const QuoteThankYouTastic = ({ data }) => {
  return <QuoteThankYou {...data} />;
};

export default QuoteThankYouTastic;
